<template>
  <!-- no dropdown -->

  <div v-if="navItem && navItem.childRoutes?.length < 1">
    <router-link
      class="flex items-center p-2 text-xs rounded-md cursor-pointer gap-x-4"
      :class="route === navItem?.name?.toLowerCase() ? active : inActive"
      :to="{ name: navItem?.name }"
    >
      <div>
        <img :src="getNavIcon(navItem?.name)" class="w-5" />
      </div>
      <p class="">{{ navItem?.name }}</p>
    </router-link>
  </div>
  <!--  -->
</template>
 
<script>
export default {
  name: "NoDropdownNav",
  props: ["navItem", "getNavIcon"],
  data() {
    return {
      active: "  text-white bg-black rounded-md ",
      inActive: "  text-black",
      route: this.$route.name?.toLowerCase(),
    };
  },
  mounted() {
    // console.log(this.navItem)
  },
};
</script>

<style></style>
